<template>
    <v-dialog v-model="dialog" max-width="1000px">
        <v-card>
            <v-card-title class="headline">{{this.$t('scheduler.title')}}</v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="4">
                            <v-select
                            :items=functionOptions
                            label="Function"
                            v-model="cron.function"
                            />
                        </v-col>
                        <v-col cols="4">
                            <v-select
                            :items=topicNames
                            label="Topic Name"
                            v-model="cron.serviceBusRequestConfig.TopicName"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-select
                            :items=invoiceTypes
                            label="Message type"
                            v-model="cron.serviceBusRequestConfig.ApplicationProperties['InvoiceType']"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-select
                            :items=InvoiceCreationTypes
                            label="Invoice type"
                            v-model="cron.serviceBusRequestConfig.ServiceBusMessageAsJSON.invoiceType"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-select
                            :items=MessageTypes
                            label="Message Type"
                            v-model="cron.serviceBusRequestConfig.ServiceBusMessageAsJSON.messageType"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <VueCronEditorBuefy v-model="cron.cronExpression" :visibleTabs="['minutes', 'hourly', 'daily', 'weekly', 'monthly']" />
                        </v-col>
                        <v-col cols="12">
                            <span>{{this.$t('scheduler.utcNote', [utcDifference()])}}</span>
                        </v-col>
                        <v-col cols="12">
                            <v-simple-table style="max-width: 400px; margin: auto; float:left;">
                                <thead>
                                    <tr>
                                    <th>{{ $t('scheduler.newCron') }}</th>
                                    <th>{{ $t('scheduler.oldCron') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                    <td>{{ cron.cronExpression }}</td>
                                    <td>{{ oldCronString }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveCron">{{$t('common.save')}}</v-btn>
                <v-btn color="error" text @click="dialog = false">{{this.$t('common.close')}}</v-btn>
            </v-card-actions>
        </v-card>
        <v-snackbar v-model="snackbar" :color="snackbarColor">
        {{ snackbarText }}
        <v-btn text @click="snackbar = false">
          {{$t("common.close")}}
        </v-btn>
      </v-snackbar>
    </v-dialog>
</template>

<script>
import VueCronEditorBuefy from "vue-cron-editor-buefy";
import ScheduleFunctions from "@/models/scheduler/ScheduleFunctions";
import ErpSystem from "@/models/scheduler/ErpSystem";
import { InvoiceCreationType } from "@/models/InvoiceCreationType";
import MessageType from "@/models/scheduler/MessageType";
import TopicName from "@/models/scheduler/TopicName";
import InvoiceType from "@/models/scheduler/InvoiceType";
export default {
    data: function() {
        return {
            dialog: false,
            snackbar: false,
            snackbarText: "",
            snackbarColor: "",
            exists: false,
            tenant: "",
            type: "",
            cron: {
                id: null,
                function: 0,
                customProperties: {},
                retries: 0,
                retryIntervals: [],
                serviceBusRequestConfig: {
                    TopicName: "",
                    ServiceBusMessageAsJSON: {
                        erpSystem: 0,
                        creationType: 0,
                        messageType: 0
                    },
                    ApplicationProperties: {}
                },
                tenantId: ""
            },
            oldCronString: "",
            functionOptions: [],
            erpOptions: [],
            InvoiceCreationTypes: [],
            MessageTypes: [],
            topicNames: [],
            invoiceTypes: []
        };
    },
    watch: {
        dialog(val) {
            if (val === false) {
                this.$emit("closed");
            }
        }
    },
    methods: {
        openDialog(schedule) {
            this.dialog = true;
            if (schedule && schedule.id) {
                this.loadData(schedule);
            } else {
                this.exists = false;
                this.oldCronString = "";
                this.cron = {
                    id: null,
                    function: 0,
                    customProperties: {},
                    retries: 0,
                    retryIntervals: [],
                    serviceBusRequestConfig: {
                        TopicName: "",
                        ServiceBusMessageAsJSON: {
                            erpSystem: 0,
                            creationType: 0,
                            messageType: 0,
                            tenantId: ""
                        },
                        ApplicationProperties: {}
                    },
                    tenantId: ""
                };
            }

            this.functionOptions = Object.entries(ScheduleFunctions).map(([key, value]) => ({ text: key, value: value }));
            this.erpOptions = Object.entries(ErpSystem).map(([key, value]) => ({ text: key, value: value }));
            this.InvoiceCreationTypes = Object.entries(InvoiceCreationType).map(([key, value]) => ({ text: key, value: value }));
            this.MessageTypes = Object.entries(MessageType).map(([key, value]) => ({ text: key, value: value }));
            this.topicNames = Object.entries(TopicName).map(([key, value]) => ({ text: value, value: value }));
            this.invoiceTypes = Object.entries(InvoiceType).map(([key, value]) => ({ text: key, value: value }));
        },
        async saveCron() {
            try {
                if (!this.exists) {
                    await this.$store.dispatch("cronScheduler/createSchedule", this.cron);
                } else {
                    await this.$store.dispatch("cronScheduler/updateSchedule", this.cron);
                }
                this.dialog = false;
            } catch (error) {
                this.snackbarText = error;
                this.snackbarColor = "error";
                this.snackbar = true;
            }
        },
        async loadData(schedule) {
            if (schedule) {
                try {
                    const result = await this.$store
                        .dispatch("cronScheduler/getSchedule", schedule.id);

                    this.cron = result.data;
                    this.oldCronString = result.data.cronExpression;

                    let raw = this.cron.serviceBusRequestConfig; // your JSON string
                    this.cron.serviceBusRequestConfig = JSON.parse(raw);

                    // Defensive: Ensure nested objects exist
                    if (!this.cron.serviceBusRequestConfig.ApplicationProperties) {
                        this.cron.serviceBusRequestConfig.ApplicationProperties = {};
                    }
                    if (typeof this.cron.serviceBusRequestConfig.ApplicationProperties["InvoiceType"] === "undefined") {
                        this.cron.serviceBusRequestConfig.ApplicationProperties["InvoiceType"] = "";
                    }

                    this.cron.name = this.cron.customProperties["CronTickerCustomName"];

                    this.exists = true;
                } catch (error) {
                    if (error.response && error.response.status === 404) {
                        this.snackbarText = "Schedule not found (404).";
                    } else {
                        this.snackbarText = "An error occurred: " + (error.message || error);
                    }

                    this.snackbarColor = "error";
                    this.snackbar = true;
                }
            }
        },
        utcDifference() {
            const offsetMinutes = new Date().getTimezoneOffset(); // Difference in minutes
            const offsetHours = -offsetMinutes / 60; // Convert to hours, negative means ahead of UTC

            if (offsetHours > 0) {
                return "+" + offsetHours;
            }
            return offsetHours;
        }
    },
    components: {
        VueCronEditorBuefy
    }
};
</script>
